import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Downloads from "./components/Downloads";
import About from "./components/About";
import Mining from "./components/Mining";
import Staking from "./components/Staking";
import Features from "./components/Features";
import Gaming from "./components/Gaming";
import Wallet from "./components/Wallet";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <Hero />
      <Downloads />
      <About />
      <Mining />
      <Staking />
      <Features />
      <Gaming />
      <Wallet />
      <Footer />
    </div>
  );
}

export default App;
